import script from "./AboutUsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUsPage.vue?vue&type=style&index=0&id=7ce8dcf7&scoped=true&lang=css"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce8dcf7"]])

export default __exports__